import { FormattedReport } from 'src/types/formattedReports';

export const formatReportItems = <T extends { periodStart?: number }>(
  items: T[]
): FormattedReport<T>[]  => {
  let currentPeriodStart: number | undefined;

  return items.map((report, index) => {
    const spanningRow = report.periodStart !== currentPeriodStart;
    currentPeriodStart = report.periodStart;
    let rowSpan = 1;

    // For spanning rows, search subsequent rows to see how many rows this one should span.
    while (spanningRow) {
      const nextRow = items[index + rowSpan];
      if (nextRow && nextRow.periodStart === currentPeriodStart) {
        rowSpan++;
      } else {
        break;
      }
    }

    return {
      spanningRow,
      rowSpan: spanningRow ? rowSpan : undefined,
      report,
    };
  });
};
